(ns web3.queries.property
  (:require [x-vec.graphql :as x]
            [web3.persistence.queries :as q]
            [web3.queries.root :as q-root]))

(def property-fields q-root/property-fields)

(declare query mutation StreetAddressInput! ID! String String! UUID!)

(x/defn ^mutation property-transfer-start! [{:keys [^ID! propertyId
                                                    ^String firstName
                                                    ^String lastName
                                                    ^String comment
                                                    ^String! email]}]
        [:propertyTransferRequest_create {:propertyId propertyId
                                          :firstName firstName
                                          :lastName lastName
                                          :comment comment
                                          :email email}
         [:propertyTransferRequest
          [:property property-fields]]])

(x/defn ^mutation property-transfer-cancel! [{:keys [^ID! propertyId]}]
        [:propertyTransferRequest_cancel {:propertyId propertyId}
         [:property property-fields]])

(x/defn ^query property-transfer-request-info [{:keys [^UUID! id]}]
        [:propertyTransferRequest_info {:propertyTransferRequestId id}
         [:originator
          :firstName
          :lastName
          :companyName
          :email]
         :recipientEmail
         :recipientFirstName
         :recipientLastName
         [:propertyAddress :street1 :street2 :locality :region :country :postalCode]])

(x/defn ^mutation property-transfer-request-accept [{:keys [^UUID! id]}]
        [:propertyTransferRequest_accept {:propertyTransferRequestId id}
         [:property q/entity-id-fields]
         [:user q-root/root-query-fields]])

(x/defn ^mutation property-update! [{:keys [^ID! id
                                            ^String nickname
                                            ^StreetAddressInput! address]}]
  [:property_update {:id id
                     :nickname nickname
                     :address address}
   [:property property-fields]])

(x/defn ^mutation property-create! [{:keys [^String nickname
                                            ^StreetAddressInput! address]}]
  [:property_create {:nickname nickname
                     :address address}
   [:property
    q/entity-id-fields]
   [:user q-root/root-query-fields]])

(x/defn ^mutation property-clone! [{:keys [^ID! id
                                           ^String nickname]}]
  [:property_clone {:id id
                    :nickname nickname}
   [:property
    q/entity-id-fields]
   [:user q-root/root-query-fields]])

(x/defn ^mutation property-delete! [{:keys [^ID! id]}]
  [:property_delete {:id id}
   [:user
    q/entity-id-fields
    [:propertyRights
     q/entity-id-fields
     [:property
      q/entity-id-fields]]]])

(x/defn ^query property-deletion-content-check [{:keys [^UUID! id]}]
  ;; used to inform the user about what items/content will be
  ;; deleted along with a property
  [:entity {:gql/alias-of :lookupEntity
            :uuid id
            :typeName "Property"}
   q/entity-id-fields
   [:... {:on :Property}
    property-fields
    [:assetGroups
     q/entity-id-fields
     [:assets q/entity-id-fields]]
    [:contents {:recursive true
                :curated false} q/entity-id-fields]]])